module.exports = __webpack_public_path__ + "img/station.677c91e8.svg";